import React from 'react';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import styles from './SearchButton.module.scss';

export interface SearchButtonProps {
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}

export const SearchButton = ({
  disabled = false,
  loading = false,
  className,
}: SearchButtonProps) => {
  return (
    <div className={styles.container}>
      <Button
        type="submit"
        variant="contained"
        className={`${styles.searchButton} ${className}`}
        disabled={disabled || loading}
        fullWidth
      >
        {loading ? <CircularProgress size={20} className={styles.spinner} /> : 'Search'}
      </Button>
    </div>
  );
};

export default SearchButton;
